import api from '../../../utils/api';
import { normalizeInviteCodeInput } from '../utils/joinByCodeMessages';

export async function joinClubByCode(code) {
  const normalized = normalizeInviteCodeInput(code);
  const res = await api.post('/clubs/join-by-code/', { code: normalized });
  return res.data;
}
